/** @jsxImportSource @emotion/react */
// eslint-disable-next-line import/no-extraneous-dependencies
import '@qpokychuk/sf-pro-display/index.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import '@qpokychuk/sf-pro-display/normal.css'
// eslint-disable-next-line import/no-extraneous-dependencies
import '@qpokychuk/sf-pro-display/italic.css'
import { observer } from 'mobx-react-lite'
import {
  RussianPokerProvider,
  useRussianPokerStore,
} from 'providers/RussianPokerProvider'
import { FC } from 'react'
import { useParams } from 'react-router-dom'
import { RpVideoStream } from '../../components'
import { useForceVideoPortrait } from '../../hooks'
import { SidePanel } from '../../rpComponents'
import RpDepositRefillPopup from '../../rpComponents/RpDepositRefillPopup'
import RpStepDebugger from '../../rpComponents/RpStepDebugger'
import { Container } from './styles'

const RussianPokerGame: FC = observer(() => {
  const store = useRussianPokerStore()
  const VideoPortraitOverlay = useForceVideoPortrait()

  if (!store.session) return null

  return (
    <>
      {VideoPortraitOverlay}
      <RpDepositRefillPopup />
      <Container data-cy="rp-game-container" id="rp-game-container">
        <RpVideoStream />
        <SidePanel />
      </Container>
      {process.env.NODE_ENV === 'development' &&
        process.env.REACT_APP_RP_STEP_MODE === 'true' && <RpStepDebugger />}
    </>
  )
})

const RussianPoker: FC = () => {
  const params = useParams<{
    gameId: string
  }>()
  const gameId = params.gameId as string

  return (
    <RussianPokerProvider key={gameId} gameId={gameId}>
      <RussianPokerGame />
    </RussianPokerProvider>
  )
}

export default RussianPoker
